<ng-template #actionsTpl>
  <ul *ngIf="nzActions?.length > 0" class="ant-list-item-action">
    <li *ngFor="let i of nzActions; let last=last;">
      <ng-template [ngTemplateOutlet]="i"></ng-template>
      <em *ngIf="!last" class="ant-list-item-action-split"></em>
    </li>
  </ul>
</ng-template>
<ng-template #contentTpl>
  <ng-content></ng-content>
  <ng-container *ngIf="nzContent">
    <ng-container *nzStringTemplateOutlet="nzContent">{{ nzContent }}</ng-container>
  </ng-container>
</ng-template>
<ng-template #simpleTpl>
  <ng-template [ngTemplateOutlet]="contentTpl"></ng-template>
  <ng-template [ngTemplateOutlet]="nzExtra"></ng-template>
  <ng-template [ngTemplateOutlet]="actionsTpl"></ng-template>
</ng-template>
<ng-container *ngIf="isVerticalAndExtra; else simpleTpl">
  <div class="ant-list-item-main">
    <ng-template [ngTemplateOutlet]="contentTpl"></ng-template>
    <ng-template [ngTemplateOutlet]="actionsTpl"></ng-template>
  </div>
  <div class="ant-list-item-extra">
    <ng-template [ngTemplateOutlet]="nzExtra"></ng-template>
  </div>
</ng-container>